<template>
  <div class="skeleton__results">
    <Skeleton
      class="skeleton__results__header"
    />
    <div
      class="skeleton__results__content"
    >
      <div
        class="skeleton__results__content__row"
        v-for="row in dummyArray"
        :key="row.index"
      >
        <Skeleton class="skeleton__results__content__row__label" />
        <Skeleton class="skeleton__results__content__row__value" />
      </div>
    </div>
  </div>
</template>
<script>
import {Skeleton} from '@progress/kendo-vue-indicators'

export default {
  components: {
    Skeleton
  },
  props: {
    lines: {
      type: Number,
      default() {
        return 4
      }
    }
  },
  data() {
    let dummyArray = new Array(this.lines).fill({index: 0}).map((e, i) => e.index = i)
    return {
      dummyArray: dummyArray
    }
  }
}
</script>
